// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .terms-modal .p-dialog-header {
  display: none;
}

::ng-deep .terms-modal {
  background-color: white !important;
  border-radius: 2rem !important;
  overflow: hidden;
  height: 100%;
}

::ng-deep .terms-modal .p-dialog-content {
  padding: 0 !important;
  background-color: white !important;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.container {
  width: 100%;
  height: 100%;
}

.wave-content {
  height: 200px;
}

.terms-content {
  padding-left: 28px;
  padding-right: 10px;
}

.element-1 {
  position: relative;
  bottom: 285px;
}

.element-2 {
  position: relative;
  bottom: 120px;
}

.element-3 {
  position: relative;
  top: 43px;
  border-top-left-radius: 8px;
}

::ng-deep .terms-modal .p-component {
  color: white;
}
::ng-deep .terms-modal .p-component .p-icon-wrapper {
  color: white;
}
::ng-deep .terms-modal .p-component span {
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/terms/terms.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;;AAEA;EACI,kCAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;AACJ;;AAEA;EACI,qBAAA;EACA,kCAAA;EACA,6BAAA;EACA,6BAAA;AACJ;;AAGA;EACI,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,aAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,mBAAA;AAAJ;;AAIA;EACI,kBAAA;EACA,aAAA;AADJ;;AAKA;EACI,kBAAA;EACA,aAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,SAAA;EACA,2BAAA;AAFJ;;AAMA;EACI,YAAA;AAHJ;AAKI;EACI,YAAA;AAHR;AAMI;EACI,YAAA;AAJR","sourcesContent":["::ng-deep .terms-modal .p-dialog-header {\n    display: none;\n}\n\n::ng-deep .terms-modal {\n    background-color: white !important;\n    border-radius: 2rem !important;\n    overflow: hidden;\n    height: 100%;\n}\n\n::ng-deep .terms-modal .p-dialog-content {\n    padding: 0 !important;\n    background-color: white !important;\n    overflow-y: hidden !important;\n    overflow-x: hidden !important;\n\n}\n\n.container {\n    width: 100%;\n    height: 100%;\n}\n\n.wave-content {\n    height: 200px;\n}\n\n.terms-content {\n    padding-left: 28px;\n    padding-right: 10px;\n\n}\n\n.element-1 {\n    position: relative;\n    bottom: 285px;\n\n}\n\n.element-2 {\n    position: relative;\n    bottom: 120px\n}\n\n.element-3 {\n    position: relative;\n    top: 43px;\n    border-top-left-radius: 8px;\n}\n\n\n::ng-deep .terms-modal .p-component {\n    color: white;\n\n    .p-icon-wrapper {\n        color: white\n    }\n\n    span {\n        color: white\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
